export const INDUSTRY_MEAN_LABEL = 'Industry Mean';
